import { imprimirEtiquetasConversion } from './imprimirEtiquetasConversion'
import { imprimirEtiquetasVisita } from './imprimirEtiquetasVisita'
import { imprimirEtiquetasDec } from './imprimirEtiquetasDec'
import { imprimirEtiquetasExt } from './imprimirEtiquetasExt'
import { imprimirEtiquetasVenta } from './imprimirEtiquetasVenta'
import { imprimirEtiquetasDecAGR } from './imprimirEtiquetasDecAGR'

export function impresionEtiquetas(configuracionLanding) {
  imprimirEtiquetasDec(configuracionLanding)
  imprimirEtiquetasDecAGR()
  imprimirEtiquetasConversion(configuracionLanding)
  imprimirEtiquetasVisita(configuracionLanding)
  imprimirEtiquetasExt(configuracionLanding)
  imprimirEtiquetasVenta(configuracionLanding)
}
